var _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWildArt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "1 1 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "trippy",
    x: 0,
    y: 0,
    width: 0.1,
    height: 0.1,
    patternUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.05,
    y: 0.05,
    width: 0.9,
    height: 0.9,
    fill: "#FFFFE0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF00FF"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.5,0.1 0.35,0.35 0.65,0.35",
    fill: "#00FF00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.3,0.5 0.5,0.35 0.5,0.55",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.7,0.5 0.5,0.35 0.5,0.55",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.65,0.7 L 0.5,0.6 L 0.35,0.6 L 0.25,0.7 L 0.05,0.7",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.3,
    r: 0.08,
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.35,0.3 Q 0.5,0.15 0.65,0.3",
    fill: "#800000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.3,0.5 0.4,0.55 0.5,0.5 0.6,0.55 0.7,0.5",
    fill: "#008080"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.75,0.7 0.7,0.75 0.8,0.75",
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.08,
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.45,0.5 Q 0.5,0.6 0.55,0.5 Q 0.6,0.5 0.55,0.45 Q 0.5,0.4 0.45,0.45 Q 0.4,0.5 0.45,0.5 Z",
    fill: "#FF1493"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.06,
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.3,0.3 0.45,0.3 0.35,0.45",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.7,0.7 0.55,0.7 0.65,0.55",
    fill: "#00CED1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.15,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0.02 Q 0,0 0.02,0",
    fill: "#FF00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1,0.02 Q 1,0 0.98,0",
    fill: "#FF00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.02,1 Q 0,1 0,0.98",
    fill: "#FF00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.98,1 Q 1,1 1,0.98",
    fill: "#FF00FF"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#trippy)",
    opacity: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildArt);
export default __webpack_public_path__ + "static/media/wildArt.be546a8529ee22a4792ae55a37963397.svg";
export { ForwardRef as ReactComponent };